import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_URL_API_BASE,
  //timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptores
http.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default http
